import axios from "axios";
import { MessageBox } from "element-ui";
import store from "../store";
import { Getitem, Setitem } from "./item.js";

// 基础配置
const HEADER = {
  ClientId: "pc_cus",
};

const baseURL = "https://nmwtzx.com/wtzx/";

// 状态管�?
let isTokenRefreshing = false;
let isTempUser = false; // 标记是否为临时用�?

// 定时检测相关变�?
let tokenCheckInterval = null;
let lastCheckTime = 0;
const CHECK_INTERVAL = 40 * 1000;

// 检查是否为临时用户（根据userId长度判断�?
const checkIsTempUser = () => {
  const userId = Getitem("userid");
  return userId && userId.length > 30;
};

// --------------------------主动检测token有效�?--------------------------
export const checkTokenValid = async () => {
  const Stoken = Getitem("user");
  if (!Stoken) {
    return {
      isValid: false,
      reason: "token不存在",
    };
  }

  try {
    // 调用 PROtype
    const response = await PROtype(Stoken);
    // console.log('后端的返回值：', response);

    // 兼容返回格式：可能是对象，也可能是字符串
    let res;
    if (response && typeof response === "object" && "code" in response) {
      res = response;
    } else {
      res = {
        code: 500,
        msg: response || "未知错误",
      };
    }

    if (res.code === 200) {
      return {
        isValid: true,
        data: res,
      };
    } else {
      return {
        isValid: false,
        reason: `接口返回错误: ${res.code}`,
      };
    }
  } catch (error) {
    // console.log('token检测错误详�?', error);

    // 明确 401 处理逻辑
    if (error.response && error.response.status === 401) {
      return {
        isValid: false,
        reason: "token已过�?401状态码)",
      };
    }
    if (
      error.response &&
      error.response.data &&
      error.response.data.code === 401
    ) {
      return {
        isValid: false,
        reason: "token已过�?401错误�?",
      };
    }

    // 其他情况认为网络暂时异常，不立即判失�?
    return {
      isValid: true,
      reason: "网络错误，但token可能有效",
    };
  }
};

// --------------------------静默token检测并处理---------------------------
export const silentCheckToken = async () => {
  // 防止过于频繁的检�?
  const now = Date.now();
  if (now - lastCheckTime < 30000) {
    // 30秒内不重复检�?
    return true;
  }

  lastCheckTime = now;

  try {
    const result = await checkTokenValid();
    if (!result.isValid) {
      // console.log('定时检测发现Token已失�?', result.reason);
      // 执行401处理流程
      await handleTokenExpired();
      return false;
    }
    // console.log('定时检�? Token有效');
    return true;
  } catch (error) {
    // console.error('Token检测失�?', error);
    return false;
  }
};

// --------------------------开始定时检�?--------------------------
export const startTokenPeriodicCheck = () => {
  // 先停止已有的检�?
  stopTokenPeriodicCheck();

  // console.log('开始Token定时检测，间隔30�?);

  // 立即执行一次检�?
  setTimeout(() => {
    silentCheckToken();
  }, 1000);

  tokenCheckInterval = setInterval(async () => {
    const token = Getitem("user");
    if (token) {
      await silentCheckToken();
    } else {
      // console.log('未找到token，停止定时检�?);
      stopTokenPeriodicCheck();
    }
  }, CHECK_INTERVAL);
};

// --------------------------停止定时检�?--------------------------
export const stopTokenPeriodicCheck = () => {
  if (tokenCheckInterval) {
    clearInterval(tokenCheckInterval);
    tokenCheckInterval = null;
    // console.log('停止Token定时检�?);
  }
};

// token过期处理
const handleTokenExpired = async () => {
  // 防止重复处理
  if (isTokenRefreshing) {
    // console.log('token刷新中，跳过重复处理');
    return false;
  }

  isTokenRefreshing = true;
  isTempUser = checkIsTempUser();

  try {
    // 如果是临时用户，自动重新临时登录
    if (isTempUser) {
      // console.log('定时检�? 临时用户token过期，自动重新临时登�?);
      try {
        await templogin();
        return true;
      } catch (error) {
        // console.error('定时检�? 临时登录失败:', error);
        return false;
      }
    }

    // 如果是正常用户，清除token并提�?
    // console.log('定时检�? 正常用户token过期');
    Setitem("user", "");
    Setitem("name", "");
    store.commit("setusername", "");
    store.commit("setlog401", "401");

    // 使用Element UI提示用户
    return new Promise((resolve) => {
      MessageBox.confirm("您的登录状态已过期，请重新登录", "登录已过", {
        confirmButtonText: "临时登录",
        cancelButtonText: "重新登录",
        type: "warning",
        center: true,
      })
        .then(() => {
          // 用户选择临时登录
          // console.log('用户选择临时登录');
          templogin()
            .then(() => {
              resolve(true);
            })
            .catch(() => {
              resolve(false);
            });
        })
        .catch(() => {
          // 用户选择重新登录
          // console.log('用户选择重新登录');
          store.commit("setSlogin", true);
          resolve(false);
        });
    });
  } finally {
    isTokenRefreshing = false;
  }
};

// 初始化axios实例
const service = axios.create({
  baseURL: baseURL,
  timeout: 10000,
  headers: HEADER,
});

service.interceptors.request.use(
  (config) => {
    const token = Getitem("user");
    if (token) {
      config.headers.token = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;

    if (res.code === 401) {
      handle401();
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      handle401();
    }
    return Promise.reject(error);
  },
);

async function handle401() {
  // 清除本地存储的用户信�?
  Setitem("user", "");
  Setitem("name", "");
  store.commit("setusername", "");
  store.commit("setlog401", "401");

  // 弹出提示
  await showTokenInvalidDialog();
}

// 显示token无效的对话框
function showTokenInvalidDialog() {
  templogin();
  store.commit("setusername", "");
  Setitem("name", "");
  return new Promise((resolve) => {
    MessageBox.confirm("已在其他电脑登录，本地已下线", "提示", {
      confirmButtonText: "临时登录",
      cancelButtonText: "重新登录",
      type: "warning",
      center: true,
    })
      .then(() => {
        store.commit("setStemp", true);
      })
      .catch(() => {
        store.commit("setSlogin", true);
      });
  });
}

// --------------------------初始化用户检�?--------------------------
export const initUserCheck = () => {
  const token = Getitem("user");
  const userId = Getitem("userid");

  isTempUser = checkIsTempUser();
  // console.log('初始化用户类型检�?', isTempUser ? '临时用户' : '正常用户');

  // 如果有token，启动定时检�?
  if (token && userId) {
    // console.log('检测到用户已登录，启动Token定时检�?);
    startTokenPeriodicCheck();
  } else {
    // console.log('用户未登录，不启动Token定时检�?);
  }
};

// 应用启动时执行用户类型检�?
initUserCheck();

// --------------------------登录---------------------------
export const login = async (data) => {
  try {
    const response = await service({
      url: "sys/login",
      method: "POST",
      data: data,
      headers: {
        ClientId: "pc_cus",
      },
    });

    const res = response.data;
    // console.log(res);

    if (res.code === 200) {
      Setitem("user", res.token);
      Setitem("userid", res.userId);
      isTempUser = false; // 标记为正常用�?
      store.commit("setlog401", "");

      // 登录成功后启动定时检�?
      startTokenPeriodicCheck();

      return res;
    } else {
      return res.msg;
    }
  } catch (error) {
    throw error;
  }
};

// ------------------------临时登录--------
export const templogin = async (
  data = {
    username: Date.now(),
    password: Date.now(),
  },
) => {
  try {
    const response = await service({
      url: "pc/temp",
      method: "POST",
      data: data,
    });

    const res = response.data;
    // console.log(res);

    if (res.code === 200) {
      Setitem("user", res.token);
      Setitem("userid", res.token);
      isTempUser = true; // 标记为临时用�?
      store.commit("setlog401", "");

      // 临时登录成功后也启动定时检�?
      startTokenPeriodicCheck();

      return res;
    } else {
      return res.msg;
    }
  } catch (error) {
    throw error;
  }
};

// ------------------------------全部项目目录------------------------------
export const PROtype = async (token) => {
  try {
    const response = await service({
      url: "project/type/queryAll",
      method: "GET",
      headers: {
        ClientId: "pc_cus",
        token,
      },
    });

    const res = response.data;
    // console.log(res);

    if (res.code === 200) {
      let list = res.list;
      let setkeylist = list.map((res) => res.intent);
      let keylist = [...new Set(setkeylist)];
      let newlist = [];

      await keylist.forEach((r) => {
        let s = {
          name: r,
          list: [],
        };
        const filteredList = list.filter((s) => s.intent === r);
        s.list = filteredList;
        newlist.push(s);
      });
      await Setitem("setmenu", newlist);
      store.commit("SETprjectmenu", newlist);
      return res;
    } else {
      return res.msg;
    }
  } catch (error) {
    throw error;
  }
};
// --------------------------查询子类======================
export const subclass = async (id) => {
  try {
    const response = await service({
      url: `subclass/byProjectTypeId/${id}`,
      method: "GET",
    });
    const res = response.data;
    if (res.code === 200) {
      return res;
    } else {
      return res.msg;
    }
  } catch (error) {
    throw error;
  }
};
// --------------------------查询所有后台管理员======================
export const manage = async () => {
  try {
    const response = await service({
      url: `manage/user/all`,
      method: "GET",
    });

    const res = response.data;
    if (res.code === 200) {
      return res;
    } else {
      return res;
    }
  } catch (error) {
    throw error;
  }
};
// --------------------------上传资料======================
export const upzl = async (data) => {
  try {
    const response = await service({
      url: `project/update`,
      method: "POST",
      data,
    });
    const res = response.data;
    if (res.code === 200) {
      return res;
    } else {
      return res.msg;
    }
  } catch (error) {
    throw error;
  }
};
// -- -- -- -- -- -- -- -- -查询专业-- -- -- -- -- -- -- -- -- -- -- --
export const zyemg = async (id) => {
  try {
    const response = await service({
      url: `informations/queryBySubclassId/${id}`,
      method: "GET",
    });

    const res = response.data;
    if (res.code === 200) {
      return res;
    } else {
      return res.msg;
    }
  } catch (error) {
    throw error;
  }
};
// -------------------------注册---------------------------
export const signserve = async (data) => {
  try {
    const response = await service({
      url: `cus/user/save`,
      method: "POST",
      data,
    });

    const res = response.data;
    if (res.code === 200) {
      return res;
    } else {
      return res.msg;
    }
  } catch (error) {
    throw error;
  }
};
// -------------------------新项目注�?--------------------------
export const prjpush = async (data) => {
  try {
    const response = await service({
      url: `project/save`,
      method: "POST",
      data,
    });

    const res = response.data;
    if (res.code === 200) {
      return res;
    } else {
      return res.msg;
    }
  } catch (error) {
    throw error;
  }
};
// -------------------------查询用户所有项�?--------------------------
export const ALLprj = async (data) => {
  try {
    const response = await service({
      url: `project/queryByCusUserId`,
      method: "GET",
      data,
    });

    const res = response.data;
    if (res.code === 200) {
      return res;
    } else {
      return res.msg;
    }
  } catch (error) {
    throw error;
  }
};
// -------------------------修改项目（总表�?--------------------------
export const editPRJ = async (data) => {
  try {
    const response = await service({
      url: `project/update`,
      method: "POST",
      data,
    });

    const res = response.data;
    if (res.code === 200) {
      return res;
    } else {
      return res.msg;
    }
  } catch (error) {
    throw error;
  }
};
// -------------------------增加项目资料（总表�?--------------------------
export const addzl = async (data) => {
  try {
    const response = await service({
      url: `project/insert`,
      method: "POST",
      data,
    });

    const res = response.data;
    if (res.code === 200) {
      return res;
    } else {
      return res.msg;
    }
  } catch (error) {
    throw error;
  }
};
// -------------------------修改项目资料（总表�?--------------------------
export const editxmzl = async (data) => {
  try {
    const response = await service({
      url: `project/update/information`,
      method: "POST",
      data,
    });

    const res = response.data;
    if (res.code === 200) {
      return res;
    } else {
      return res.msg;
    }
  } catch (error) {
    throw error;
  }
};

// ------------------------------差评-----------------------------
export const chap = async (data) => {
  try {
    const response = await service({
      url: `engineer/user/evaluate`,
      method: "GET",
      params: data,
    });

    const res = response.data;
    if (res.code === 200) {
      return res;
    } else {
      return res.msg;
    }
  } catch (error) {
    throw error;
  }
};
// ------------------------------支付项目费用-----------------------------
export const payProject = async (data) => {
  try {
    const response = await service({
      url: `cus/user/pc/pay`,
      method: "post",
      data,
    });

    const res = response.data;
    if (res.code === 200) {
      return res;
    } else {
      return res.msg;
    }
  } catch (error) {
    throw error;
  }
};

// ------------------------------使用免费码支付项目费用-----------------------------
export const payProjectByCode = async (data) => {
  try {
    const response = await service({
      url: `cus/user/code/pay`,
      method: "post",
      data,
    });

    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      return error.response.data;
    }
    throw error;
  }
};
// ----------------------查询支付状态接�?--------------------------

export const checkPayStatus = async (paymentNum) => {
  try {
    const response = await service({
      url: `cus/user/pay/status/${paymentNum}`,
      method: "get",
    });

    const res = response.data;
    if (res.code === 200) {
      return res;
    } else {
      return res.msg;
    }
  } catch (error) {
    throw error;
  }
};

// -----------------------------撤消-----------------------------
export const delchap = async (data) => {
  try {
    const response = await service({
      url: `engineer/user/evaluate/revoke`,
      method: "GET",
      params: data,
    });

    const res = response.data;
    if (res.code === 200) {
      return res;
    } else {
      return res.msg;
    }
  } catch (error) {
    throw error;
  }
};

// -----------------------------修改帐号密码-----------------------------
export const editpassword = async (data) => {
  try {
    const response = await service({
      url: `cus/user/update/password`,
      method: "POST",
      data,
    });

    const res = response.data;
    if (res.code === 200) {
      return res;
    } else {
      return res.msg;
    }
  } catch (error) {
    throw error;
  }
};

//-------------------聊天上传--------------------------------
export const uploadFile = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const res = await axios.post(
      "https://nmwtzx.com/wtzx/project/type/upload",
      formData,
      {
        headers: {
          ClientId: "pc_cus",
          token: Getitem("user"),
          "Content-Type": "multipart/form-data",
        },
      },
    );
    // console.log('是什�?, res);
    if (res.code === 401) {
      handle401();
    } else {
      return res.data; // 返回接口的响应内�?
    }
  } catch (error) {
    // console.error("文件上传失败:", error);
    throw error;
  }
};

// 导出状态检查函�?
export const checkAuthStatus = () => {
  const userId = Getitem("userid");
  const isTemp = checkIsTempUser();

  return {
    isTempUser: isTemp,
    token: Getitem("user"),
    userId: userId,
    userType: isTemp ? "临时用户" : "正常用户",
  };
};

// 清除登录状�?
export const clearAuth = () => {
  Setitem("user", "");
  Setitem("userid", "");
  isTempUser = false;
  // 停止定时检�?
  stopTokenPeriodicCheck();
};

export default {
  login,
  templogin,
  PROtype,
  subclass,
  zyemg,
  signserve,
  prjpush,
  ALLprj,
  editPRJ,
  addzl,
  editxmzl,
  chap,
  delchap,
  editpassword,
  uploadFile,
  checkTokenValid,
  silentCheckToken,
  startTokenPeriodicCheck,
  stopTokenPeriodicCheck,
  initUserCheck,
  checkAuthStatus,
  clearAuth,
  checkPayStatus,
  payProject,
  payProjectByCode,
  manage,
};
